import React, { useState, useRef, useEffect } from "react";

interface ColorPickerProps {
  value?: string;
  isSmall?: boolean;
  isCamo?: boolean;
  defaultColor?: string;
  onChange?: (color: string) => void;
  className?: string;
}

const ColorPicker: React.FC<ColorPickerProps> = ({
  value,
  isSmall = false,
  isCamo = false,
  defaultColor,
  onChange,
  className = "",
}) => {
  const [currentColor, setCurrentColor] = useState<string | null>(
    value || defaultColor || null
  );

  const inputRef = useRef<HTMLInputElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setCurrentColor(value || null);
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newColor = e.target.value;
    setCurrentColor(newColor);
    onChange?.(newColor);
  };

  return (
    <div
      className={`flex aspect-square h-full flex-none items-center justify-center rounded-full ${
        isCamo ? "" : "border-1 p-0.5 border-gray-200"
      } ${className}`}
    >
      <div
        ref={wrapperRef}
        className="relative flex aspect-square w-full flex-none rounded-full"
        style={{ backgroundColor: currentColor || undefined }}
      >
        {!currentColor && (
          <div className="absolute inset-0 m-0.5 flex items-center justify-center overflow-hidden">
            <div
              className={`absolute w-64 -rotate-45 bg-red-300 ${
                isSmall ? "h-0.5" : "h-1"
              }`}
            ></div>
          </div>
        )}
        <input
          type="color"
          ref={inputRef}
          value={currentColor || ""}
          className="h-full w-full opacity-0"
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default ColorPicker;
